import React, { Fragment, useState } from "react";
import { Button } from "../../common";
import Hints from "./Hints";
import * as style from "./styles.module.scss";
import FileDropzoneNew from "../../common/FileDropzoneNew";

const AddSelfie = ({
  setStep,
  previousStep,
  file,
  handleChange,
  hints,
  step,
}) => {
  const [isValidFileType, setIsValidFileType] = useState(true);

  const onImageUpload = (key, value) => {
    handleChange(key, value);
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  return (
    <Fragment>
      <div>
        {(step === 0 || step === 1) && previousStep !== "student" && (
          <div className="mb-2">
            This information will be shared with any one of our partners that
            you work with when contracted to HRGO for auditing purposes and so
            that they can verify your right to work in the UK.
          </div>
        )}
        <div className={"mb-4"}>
          <div className="mb-1">{`${
            previousStep === "student" ? "3" : "1"
          }. Upload a photo of yourself (JPEG or PNG)`}</div>
          <FileDropzoneNew
            handleChange={onImageUpload}
            fileStateName="selfieFile"
            fileParsedToString={file}
            handleInvalidType={() => setIsValidFileType(false)}
            isFileValid={isValidFileType}
            wrongFileTypeHint="Your image needs to be provided as a JPEG or PNG file."
          />
        </div>
        <Hints hints={hints} />
      </div>
      <div className={`mt-4 mb-lg-2 ${style.actions}`}>
        <Button
          classes="btn btn-outline-info text-dark mr-1"
          onClick={handleBack}
        >
          Back
        </Button>
        <Button
          classes="btn btn-primary btn-block"
          onClick={() => setStep(step + 1)}
          disabled={!file}
        >
          Next
        </Button>
      </div>
    </Fragment>
  );
};

export default AddSelfie;
